import { Inject, Injectable } from "@angular/core";
import { Http, Headers } from '@angular/http';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from 'exceljs';
import { saveAs } from 'file-saver';
import * as moment from 'moment';

declare const ExcelJS: any;
// declare let jsPDF;


@Injectable()
export class GenerateXmlService {
  
  representativeListExcel:any=[];
  splittedData;
  // countries: any = [];
  constructor() { }
  addRowStyle() {}
  replace(text){
    if(text){
      
     text= text.replace(/&/g, '&amp;');

    }
    else{
      text="";
    }
  

    return text;
  }
  generateXml(splittedData){
    this.splittedData=splittedData;
    var body='';
    body += `<?xml version="1.0" encoding="utf-8"?>`;
    body += `<BLUEBOOKINFO>`;

   var array=['1','2','4','5','6'];
   var fileName = "" + '.xml';

   array.forEach(char=>{
    splittedData.country[char].forEach(element => {
      this.changeMissionExcel(element,parseInt(char));
      body += `<MISSION>`;
      body += `<NAME>`;
     body+= element["MC_EntityShort"];
      if(element["MC_MembershipDate"]){
        body += `<MEMBER_DATE>`;
        body+=" Member State since "+this.replace(element["MC_MembershipDate"])+" ";
        body += `</MEMBER_DATE>`;
      }
    
      body += `</NAME>`;
      if(element['MC_Address'] && element['MC_Address']!=""){
        body += `<ADDRESS>`;
        body+="Address:      "+this.replace(element['MC_Address']);
        body += `</ADDRESS>`;
      }
     if(element['MC_Telephone'] && element['MC_Telephone']!=""){
      body += `<PHONE>`;
      body+="Telephone:      "+this.replace(element['MC_Telephone']);
      body += `</PHONE>`;
     }
     if(element['MC_Telefax'] && element['MC_Telefax']!=""){
      body += `<FAX>`;
      body+="Telefax:      "+this.replace(element['MC_Telefax']);
      body += `</FAX>`;
     }
    if(element['MC_eMail'] && element['MC_eMail']!=""){
      body += `<EMAIL>`;
      body+="e-mail:      "+this.replace(element['MC_eMail']);
      body += `</EMAIL>`;
    }
 if(element['MC_WebSite'] && element['MC_WebSite']!=""){
  body += `<WEBSITE>`;
  body+="Website:      "+this.replace(element['MC_WebSite']);
  body += `</WEBSITE>`;
 }
 if(element['MC_SocialMedia'] && element['MC_SocialMedia']!=""){

  body+=`<SOCIAL_MEDIA>`;
  body+="Social media:      "+this.replace(element['MC_SocialMedia']);
  body+=`</SOCIAL_MEDIA>`;
 }
if(element['MC_UNCorrespondenceLanguage'] && element['MC_UNCorrespondenceLanguage']!=""){
  body+=`<CORRESPONDENCE>`;
  body+="Correspondence:      "+this.replace(element['MC_UNCorrespondenceLanguage']);
  body+=`</CORRESPONDENCE>`;
}
 if(element['MC_Holiday'] && element['MC_Holiday']!=""){
  body+=`<HOLIDAY>`;
  body+="National holiday:      "+this.replace(element['MC_Holiday']);
  body+=`</HOLIDAY>`;
 }

      body += `<PR_NAME>`;
      var element=this.representativeListExcel[0];
      if(element['BB_PhnNumber'] && element['BB_PhnNumber']!=""){
        body += `<PR_EXTENSION>`;
        body+=element['BB_PhnNumber'];
        body += `</PR_EXTENSION>`;
      }
     
      body+= this.replace(element["BB_Title"])+" "+this.replace(element["BB_FirstName"])+" "+`<BOLD>`+ 
      this.replace(element["BB_LastName"])+`  </BOLD>`;
      if(element["BB_Dipl_Rank"] && element["BB_Dipl_Rank"]!="(no dipl rank)"){
        body+= " \n"+ this.replace(element["BB_Dipl_Rank"]);

      }
      if(element["BB_Function"] && element["BB_Function"]!=""){
       body+= (element["BB_Cred_Presented"]? " \n"+ element["BB_Function"]+" (DPC:"+ moment(element["BB_Cred_Presented"]).format('DD MMM YYYY')+")": " \n"+ this.replace(element["BB_Function"]));
      }
     
      body+=(!element["BB_Function"]) ? " (DPC:"+ moment(element["BB_Cred_Presented"]).format('DD MMM YYYY')+")": ""
      body+=element["BB_Email"]  ? " \n"+ this.replace(element["BB_Email"]):"";
      body+=element["BB_Spouse"] ? " \n"+this.replace( element["BB_Spouse"]):"";
      body += `</PR_NAME>`;
      body += `<DELEGATES_LIST>`;
      for(var i=1;i<this.representativeListExcel.length;i++){
       var element=this.representativeListExcel[i];
        body += `<DLG_NAME>`;
        if(element['BB_PhnNumber'] && element['BB_PhnNumber']!=""){
          body += `<DLG_EXTENSION>`;
          body+=this.replace(element['BB_PhnNumber']);
            body += `</DLG_EXTENSION>`;
        }
      
 
        body+= this.replace(element["BB_Title"])+" "+this.replace(element["BB_FirstName"])+" "+`<BOLD>`+
        this.replace( element["BB_LastName"])+`  </BOLD>`;
        if(element["BB_Dipl_Rank"] && element["BB_Dipl_Rank"]!="(no dipl rank)"){
          body+= " \n"+ this.replace(element["BB_Dipl_Rank"]);
  
        }
        if(element["BB_Function"] && element["BB_Function"]!=""){
         body+=  " \n"+this.replace(element["BB_Function"]);
        }
       
        body+=element["BB_Email"]  ? " \n"+ this.replace(element["BB_Email"]):"";
        body+=element["BB_Spouse"] ? " \n"+ this.replace(element["BB_Spouse"]):"";
        body += `</DLG_NAME>`;
      }
    
      body += `</DELEGATES_LIST>`;
      body += `</MISSION>`;
    });
   })


    body += `</BLUEBOOKINFO>`;
           
   


const blob = new Blob([body], {type : 'application/xml'});
var date=moment(new Date()).format('YYYYMMDD');
saveAs(blob, 'BlueBook'+date+'.xml'); 
  }  


  changeMissionExcel(mission,category){
    this.representativeListExcel = [];

    const l = this.splittedData.bluebook.map(i => i['BB_Mission']).indexOf(mission['MC_Entity']);
    const r = this.splittedData.bluebook.map(i => i['BB_Mission']).lastIndexOf(mission['MC_Entity']);

    this.representativeListExcel = this.splittedData.bluebook.slice(l, r + 1);
    this.representativeListExcel.forEach(delegateBB=>{
      if(delegateBB["BB_Dipl_Rank_Display"]==""){
        if(delegateBB["BB_Dipl_Rank"]==""){
          delegateBB["BB_Dipl_Rank_Display"]="(no dipl rank)";
        }
        else{
          delegateBB["BB_Dipl_Rank_Display"]=delegateBB["BB_Dipl_Rank"];
        
        }
      }
     
    })
    
    this.representativeListExcel.sort((a, b) => {
      // if (!a['BB_Dipl_Rank'] && !b['BB_Dipl_Rank']) {
      //   return a['BB_LastName'].localeCompare(b['BB_LastName']);
      // } else if (!a['BB_Dipl_Rank']) {
      //     return 1;
      // } else if (!b['BB_Dipl_Rank']) {
      //   return -1;
      // } else {
        
      //   if (a['BB_Dipl_Rank'] === b['BB_Dipl_Rank']) {
      //     return this.checkOrder(a['BB_Function']) - this.checkOrder(b['BB_Function']);
      //   } else {

      //     return this.checkOrder(a['BB_Dipl_Rank_Display']) - this.checkOrder(b['BB_Dipl_Rank_Display']);
      //   }
      // }
      const rank=  this.checkOrder(a['BB_Dipl_Rank_Display']) - this.checkOrder(b['BB_Dipl_Rank_Display']);
const position=a.BB_Position-b.BB_Position;
return rank||position;

    });

    if (category === 1 &&
      (this.representativeListExcel.length === 0 || (this.representativeListExcel[0]['BB_Function'] !== 'Permanent Representative' &&
        this.representativeListExcel[0]['BB_Dipl_Rank'] !== 'Ambassador Extraordinary and Plenipotentiary'))) {
          this.representativeListExcel.unshift({
          BB_Dipl_Rank: 'Ambassador Extraordinary and Plenipotentiary',
          BB_FirstName: '',
          BB_Function: 'Permanent Representative (DPC: ...)',
          BB_LastName: '',
          BB_PhnNumber: '',
          BB_Spouse: '',
          BB_Title: 'H.E. ...',
          BB_Cred_Presented: '',
          BB_Email: ''
        });
      }

    if ([2, 4, 5].indexOf(category) !== -1 &&
      (this.representativeListExcel.length === 0 ||
      (this.representativeListExcel[0]['BB_Function'] !== 'Permanent Observer' &&
      this.representativeListExcel[0]['BB_Dipl_Rank'] !== 'Permanent Observer' &&
      this.representativeListExcel[0]['BB_Dipl_Rank_Display'] !== 'Permanent Observer' &&
      this.representativeListExcel[0]['BB_Dipl_Rank'] !== 'Ambassador Extraordinary and Plenipotentiary'))) {
        this.representativeListExcel.unshift({
          BB_Dipl_Rank: '',
          BB_FirstName: '',
          BB_Function: 'Permanent Observer',
          BB_LastName: '',
          BB_PhnNumber: '',
          BB_Spouse: '',
          BB_Title: '...',
          BB_Cred_Presented: '',
          BB_Email: ''
        });
      }
      if (category == 6 &&
      (this.representativeListExcel.length === 0 ||
      (this.representativeListExcel[0]['BB_Function'] !== 'Permanent Observer' &&
      this.representativeListExcel[0]['BB_Dipl_Rank'] !== 'Permanent Observer' &&
      this.representativeListExcel[0]['BB_Dipl_Rank_Display'] !== 'Permanent Observer' &&
      this.representativeListExcel[0]['BB_Dipl_Rank'] !== 'Ambassador Extraordinary and Plenipotentiary'))) {
        this.representativeListExcel.unshift({
          BB_Dipl_Rank: '',
          BB_FirstName: '',
          BB_Function: '',
          BB_LastName: '',
          BB_PhnNumber: '',
          BB_Spouse: '',
          BB_Title: '...',
          BB_Cred_Presented: '',
          BB_Email: ''
        });
      }

   
  }
  checkOrder(rank) {
    switch (rank) {
      case 'Ambassador Extraordinary and Plenipotentiary':
        return 0;
      case 'Apostolic Nuncio':
        return 1;
      case 'Permanent Observer':
        return 2;
      case 'Ambassador':
        return 3;
      case 'Envoy Extraordinary and Minister Plenipotentiary':
        return 4;
      case 'Minister Plenipotentiary':
        return 5;
      case 'Minister':
        return 6;
      case 'Minister Counsellor':
        return 7;
      case 'Senior Counsellor':
        return 8;
      case 'First Counsellor':
        return 9;
      case 'Second Counsellor':
        return 10;
      case 'Third Counsellor':
        return 11;
      case 'Fourth Counsellor':
        return 12;
      case 'Fifth Counsellor':
        return 13;
      case 'Counsellor':
        return 14;
      case 'Deputy Counsellor':
        return 15;
      case 'First Secretary':
        return 16;
      case 'Second Secretary':
        return 17;
      case 'Third Secretary':
        return 18;
      case 'Attaché':
        return 19;
      case 'Assistant Attaché':
        return 20;
      case 'Senior Adviser':
        return 21;
      case 'Adviser':
        return 22;
      case '(no dipl rank)':
        return 23;
      case 'Administrative section':
        return 24;
      case 'Legal section':
        return 25;
      case 'Military section':
        return 26;
      case 'Military support section':
        return 27;
      case 'Press Section':
        return 28;
      case `Don't exceed this numbe`:
        return 29;
      default:
        return 100;
    }
  }


}


// WEBPACK FOOTER //
// ./src/app/services/generate-xml.service.ts